// extracted by mini-css-extract-plugin
export default {"email_module":"EmailForm_email_module__4159e","header":"EmailForm_header__wVOkn"};